import {PoderesEsferasOptions} from "@types";
import {FiltroSearch} from "../FiltroSearch/FiltroSearch";
import "./NavegacaoHeaderContent.scss";

interface NavegacaoHeaderContentProps {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  poderesOptions: PoderesEsferasOptions[];
  esferasOptions: PoderesEsferasOptions[];
  esferaCheckedState: boolean[];
  updateEsferaCheckedState: (pos: number) => void;
  handleApplyFilter: () => void;
  handleEnterKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  setSearchString: (value: string) => void;
  poderCheckedState: boolean[];
  updatePoderCheckedState: (value: number) => void;
  handleGetChips: () => JSX.Element;
  searchString: string;
  verifyEsferaCheckedState: () => boolean;
  verifyPoderCheckedState: () => boolean;
}

const NavegacaoHeaderContent = ({
  poderesOptions,
  setShowModal,
  showModal,
  esferaCheckedState,
  esferasOptions,
  updateEsferaCheckedState,
  handleApplyFilter,
  handleEnterKeyPress,
  poderCheckedState,
  updatePoderCheckedState,
  handleGetChips,
  setSearchString,
  searchString,
  verifyEsferaCheckedState,
  verifyPoderCheckedState,
}: NavegacaoHeaderContentProps) => {
  return (
    <div className="navegacao-header-container">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <h1 className="purple-text bold navegacao-title">Diários Oficiais</h1>

        <div style={{textAlign: "center"}}>
          <span className="navegacao-subtitle">
            <strong>Navegue</strong>{" "}
            <span>nos Diários Oficiais da União, Estados e Municípios.</span>
          </span>
        </div>
        <FiltroSearch
          esferasOptions={esferasOptions}
          handleApplyFilter={handleApplyFilter}
          poderesOptions={poderesOptions}
          setShowModal={setShowModal}
          showModal={showModal}
          handleEnterKeyPress={handleEnterKeyPress}
          esferaCheckedState={esferaCheckedState}
          updateEsferaCheckedState={updateEsferaCheckedState}
          poderCheckedState={poderCheckedState}
          updatePoderCheckedState={updatePoderCheckedState}
          handleGetChips={handleGetChips}
          setSearchString={setSearchString}
          searchString={searchString}
          verifyEsferaCheckedState={verifyEsferaCheckedState}
          verifyPoderCheckedState={verifyPoderCheckedState}
        />
      </div>
    </div>
  );
};

export default NavegacaoHeaderContent;
